import React from 'react'

const HomeMachineLearning = () => {
  return (
    <div>HomemachineLearning</div>
  )
}

export default HomeMachineLearning